<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
//import axios from 'axios'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel);
export default {
  name: 'app',
  data: () => {
    return {
      showViews: true,
      configuration: []
    }
  },
  mounted() {
    this.authchecked();
    this.tokenExpiredCheck()
  },
  updated() {
     this.tokenExpiredCheck()
  },
  methods: {
    authchecked:  function() {
      if(this.$store.state.user.logged===1)
      {
        this.$router.push('/').catch(err => { console.log(err) })
      }
      else
      {
        this.redirectToLogin()
      }
    },
    tokenExpiredCheck: function () {
      if(this.$store.state.user.data.expire)
      {
        let expire = this.$moment(this.$store.state.user.data.expire);
        let now = this.$moment();
          if( now > expire){
            this.$store.commit('logoutuser');
            this.redirectToLogin()
          }
      }
      else{
        this.redirectToLogin()
      }
    },
    redirectToLogin: function () {
      if(this.$route.path !== '/login')
        this.$router.push('/login').catch(err => { console.log("Error:" + err) })
    },
    sendConfiguration: function () {
      this.configuration = this.$store.getters.userPermits
    },
    checkPermits: function () {
      if(this.configuration.emiteFactura === 0){
        this.showViews = false
      }else{
        this.showViews = true
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import '~@fortawesome/fontawesome-free/css/all.css';
  @import '~@fortawesome/fontawesome-free/css/brands.css';
  @import '~@fortawesome/fontawesome-free/css/solid.css';
  @import '~@fortawesome/fontawesome-free/css/regular.css';
  @import '~vue-snotify/styles/material.css';
  @import 'assets/scss/style';
  
</style>
